import React from 'react'

export default function FAQ() {
  return (
    <section className="section-equal-padding bg-white">
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6">
                    <div className="faq_left" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <h2>Frequently Asked
                            Questions</h2>
                        <p>Plan your solo Atlanta adventure with confidence.
                            Find essential answers about safety, travel requirements, language, and more— all in one
                            helpful place.</p>
                        {/* <button type="button" className="regular-btn">Still Have Questions?</button> */}
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="faq_right" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <div className="accordion" id="faqAccordion">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingOne">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Is Atlanta safe for solo female travelers?
                                    </button>
                                </h2>
                                <div id="collapseOne" className="accordion-collapse collapse show"
                                    aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                                    <div className="accordion-body">
                                        Yes, Atlanta is generally safe for solo female travelers. As with any city, it's
                                        wise to stay in well-lit, populated areas and remain aware of your surroundings,
                                        especially after dark.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingTwo">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        What language is spoken in New Orleans?
                                    </button>
                                </h2>
                                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo"
                                    data-bs-parent="#faqAccordion">
                                    <div className="accordion-body">
                                        The primary language spoken in New Orleans is English. However, you might also
                                        hear French and Spanish, reflecting the city's rich cultural heritage.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingThree">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree" aria-expanded="false"
                                        aria-controls="collapseThree">
                                        Do I need a visa to visit New Orleans?
                                    </button>
                                </h2>
                                <div id="collapseThree" className="accordion-collapse collapse"
                                    aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                                    <div className="accordion-body">
                                        Most visitors do not need a visa for short visits to the U.S. Visa requirements
                                        depend on your nationality. Check with the U.S. embassy or consulate for
                                        specific details relevant to your situation.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingFpur">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseFour" aria-expanded="false"
                                        aria-controls="collapseFour">
                                        What is the currency in New Orleans, and how should I handle money?
                                    </button>
                                </h2>
                                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFpur"
                                    data-bs-parent="#faqAccordion">
                                    <div className="accordion-body pb-0">The currency in New Orleans is the U.S. Dollar
                                        (USD).
                                        ATMs are plentiful, and credit cards are widely accepted. It's a good idea to
                                        carry some cash for small purchases or local markets.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
